import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import Map from "app/static/frontend/widgets/components/visualization/Map"

// action creators
import { showInSearch } from "app/static/frontend/projects-new/list/action-creators"

// selectors
import {
    selectMapVisualizationMetaValue,
    selectMapVisualizationData,
} from "app/static/frontend/widgets/selectors/mapVisualizationWidgetSelectors"
import { selectFrequencyTupleField } from "app/static/frontend/widgets/selectors/visWidgetSelectors"
import { selectWidgetDataSources } from "app/static/frontend/widgets/selectors/selectors"

const mapStateToProps = createStructuredSelector({
    data: selectMapVisualizationData,
    dataSources: selectWidgetDataSources,

    frequencyTupleField: selectFrequencyTupleField,
    mapVisualizationCustomColors: selectMapVisualizationMetaValue("map_visualization_custom_colors"),
    mapVisualizationCustomColorsKey: selectMapVisualizationMetaValue("map_visualization_custom_colors_key"),
    mapVisualizationHeatColorScale: selectMapVisualizationMetaValue("map_visualization_heat_color_scale"),
    mapVisualizationHeatColorType: selectMapVisualizationMetaValue("map_visualization_heat_color_type"),
    mapVisualizationHeatInterpolationColors: selectMapVisualizationMetaValue("map_visualization_heat_interpolation_colors"),
    mapVisualizationHeatInterpolationColorSpace: selectMapVisualizationMetaValue("map_visualization_heat_interpolation_color_space"),
    mapVisualizationHeatQuantizedColorStep: selectMapVisualizationMetaValue("map_visualization_heat_quantized_color_step"),
    mapVisualizationRegion: selectMapVisualizationMetaValue("map_visualization_region"),
})

const mapDispatchToProps = {
    showInSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(Map)
